import classnames from 'classnames';
import React from 'react';
import { useMeasure } from 'react-use';

import { PurpleGradientContainerAnimated } from '../../components/backdrops/containers';

type MetricsCardRecord = {
  metricValue: string;
  title: string;
  description?: string;
};
type MetricsCardsProps = {
  records: MetricsCardRecord[];
};
const MetricsCards: React.FC<MetricsCardsProps> = ({ records }) => {
  return (
    <div className="flex justify-center">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 max-w-[1200px] gap-6 justify-center">
        {records.map((record, index) => (
          <MetricsCard key={`metrics-card-${index}`} {...record} />
        ))}
      </div>
    </div>
  );
};
MetricsCards.displayName = 'MetricsCards';
export default MetricsCards;

/************************************************************************************************
 * Helpers
 ************************************************************************************************/

const CARD_PADDING_X = 20;
const CARD_PADDING_Y = 30;

const MetricsCard: React.FC<MetricsCardRecord> = React.memo((props) => {
  const { metricValue, title, description } = props;
  const [containerRef, { width, height }] = useMeasure();
  const [isHovered, setIsHovered] = React.useState(false);
  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="cursor-pointer text-pureWhite text-center rounded-lg max-w-[500px] md:max-w-[340px]"
    >
      <PurpleGradientContainerAnimated
        className={classnames('rounded-lg absolute z-0 opacity-0 transition-all duration-3000 ease-linear', {
          'opacity-100': isHovered,
          'opacity-0': !isHovered,
        })}
        style={{
          width: width + CARD_PADDING_X * 2,
          height: height + CARD_PADDING_Y * 2,
        }}
      />
      <div
        ref={containerRef as any}
        className={classnames('flex flex-col items-center gap-4 relative z-10', {
          'text-neonBlue': !isHovered,
          'text-pureWhite': isHovered,
        })}
        style={{ padding: `${CARD_PADDING_Y}px ${CARD_PADDING_X}px` }}
      >
        <p className="text-h1 md:text-6xl">{metricValue}</p>
        <p className="text-3xl">{title}</p>
        {description && <p>{description}</p>}
      </div>
    </div>
  );
});
MetricsCard.displayName = 'MetricsCard';
